import { UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE } from "../../actions/QuanLyThuChiNgoaiLe/actionTypes";

const initialState = {
  tungay: "01/01/2001",
  denngay: "01/01/4000",
  ten: "",
  nhanvien: "",
  loaiphieu: "0",
  pageIndex: 1,
  pageSize: 20,
  hinhThucThanhToan: "-1",
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchQuanLyThuChiNgoaiLe = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchQuanLyThuChiNgoaiLe;
